export const GET_ALL_SMS_SUCCESS = "GET_ALL_SMS_SUCCESS"
export const GET_ALL_SMS_LOADING = "GET_ALL_SMS_LOADING"
export const ADD_NEW_SMS= "ADD_NEW_SMS"
export const  DELETE_SMS = "DELETE_SMS"
export const UPDATE_SMS = "UPDATE_SMS"